module.exports = __webpack_public_path__ + "img/zl_bd.bef840f.png";